import { useState, useEffect } from "react";
import "./LandingPage.css";
import img1 from '../images/WhatsApp Image 2026-02-05 at 12.15.39.jpeg';
import img2 from '../images/WhatsApp Image 2026-02-05 at 12.15.39 (2).jpeg';
import img3 from '../images/WhatsApp Image 2026-02-05 at 14.05.09.jpeg';

const LandingPage = ({ onNext, onMusicToggle }) => {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    setAnimated(true);
  }, []);

  // Three featured images for landing page
  const photos = [
    { id: 1, src: img1 },
    { id: 2, src: img2 },
    { id: 3, src: img3 }
  ];
 


  const handleStart = () => {
    onNext();
  };

  return (
    <section className="landing-page">
      <div className="landing-content">
        {/* Animated hearts decoration */}
        <div className="decorative-hearts">
          <span className="heart-float heart-1">💕</span>
          <span className="heart-float heart-2">💖</span>
          <span className="heart-float heart-3">💗</span>
          <span className="heart-float heart-4">💝</span>
        </div>

        {/* Main title with animation */}
        <div className={`main-title ${animated ? "animate" : ""}`}>
          <h1 className="landing-title">
            <span className="title-word">For</span>
            <span className="title-word">My</span>
            <span className="title-word highlight">Lexia</span>
          </h1>
        </div>

        {/* Photo showcase */}
        <div className={`photo-container ${animated ? "show" : ""}`}>
          <div className="photo-grid">
            {photos.map((photo, index) => (
              <div 
                key={photo.id}
                className="photo-frame"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <img 
                  src={photo.src} 
                  alt={`Our memory ${photo.id}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="photo-placeholder" style={{ display: 'none' }}>
                  <span>📸 Photo {photo.id}</span>
                </div>
                <div className="photo-glow"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Animated text content */}
        <div className={`text-content ${animated ? "show" : ""}`}>
          <p className="landing-subtitle">
            A special journey through our story
          </p>
          <div className="message-box">
            <p className="landing-message">
              Every moment with you is a treasure.
            </p>
            {/* <p className="landing-message">
              Today, I want to share something special with you.
            </p> */}
          </div>
        </div>

        {/* Call to action section */}
        <div className={`cta-section ${animated ? "show" : ""}`}>
          <button 
            className="btn-primary start-btn"
            onClick={handleStart}
          >
            <span className="btn-text">Begin Our Story</span>
            <span className="btn-icon">→</span>
          </button>
          {/* <p className="cta-hint">Tap to start your journey</p> */}
        </div>

        {/* Decorative elements */}
        <div className="landing-decoration">
          <div className="decoration-line line-1"></div>
          <div className="decoration-line line-2"></div>
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
